/*
  CheckboxWithLabel.jsx
*/

// Npm.
import React, { useMemo } from 'react';

// Components.
import Checkbox from './Checkbox';

// Makes.
import { makeStyles, cx } from '../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.color_text_primary,
    '&.disabled': {
      cursor: 'inherit',
      color: theme.color_text_disabled,
    },
    '&.fullWidth': {
      display: 'flex',
    },
    '&.readOnly': {
      cursor: 'inherit',
    },
    '& > .Checkbox': {
      marginRight: theme.space(1),
    },
    '& > .label': {
      flex: '1 1 0px',
    },
  }
}));

/**
 * A wrapper around a checkbox that has a label.
 */
export default function CheckboxWithLabel({
  className,
  label,
  title,
  disabled = false,
  readOnly = false,
  fullWidth,
  ...rest
}) {

  let rootClass = 'CheckboxWithLabel body2';

  if (disabled) {
    rootClass += ' disabled';
  }

  if (fullWidth) {
    rootClass += ' fullWidth';
  }

  if (readOnly) {
    rootClass += ' readOnly';
  }

  const classes = useStyles();
  const cls = useMemo(() => cx(rootClass, classes.root, className), [rootClass, classes.root, className]);

  return (
    <label title={title} className={cls}>
      <Checkbox disabled={disabled} readOnly={readOnly} {...rest} />
      <span className="label">{ label }</span>
    </label>
  );
}
